import { render, staticRenderFns } from "./PsiraSpecializedQualifications.vue?vue&type=template&id=1d7773d6&scoped=true&"
import script from "./PsiraSpecializedQualifications.vue?vue&type=script&lang=ts&"
export * from "./PsiraSpecializedQualifications.vue?vue&type=script&lang=ts&"
import style0 from "./PsiraSpecializedQualifications.vue?vue&type=style&index=0&id=1d7773d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7773d6",
  null
  
)

export default component.exports